export default {
  label: {
    title: {
      hiddeCard: 'Hidden component',
    },
    description: 'Following the General Data Protection Law (LGPD), it is not possible to view components with data that exposes the identity of the authors of the publications. As this dashboard is shared with invited users, the component you are adding now will be hidden from sharing. To see the list of hidden components, go to the Sharing area.',
    button: {
      aboutSharing: 'About sharing',
      confirm: 'Got it',
      cancel: 'Cancel',
    },
  },
};
